import React from 'react';
import {Switch} from 'material-ui';
import './OptionalRoundTogglers.css';

function OptionalRoundTogglers({
	onWarmupToggle,
	onCooldownToggle,
	isWarmupToggled,
	isCooldownToggled,
	warmupLabel,
	cooldownLabel,
}) {
	return (
		<div className='optionalRoundTogglersWrapper'>
			<div className='optionalRoundToggler'>
				<label>{warmupLabel}</label>
				<Switch
					checked={isWarmupToggled}
					onChange={(_, val) => {
						onWarmupToggle(val);
					}}
				/>
			</div>
			<div className='optionalRoundToggler'>
				<label>{cooldownLabel}</label>
				<Switch
					checked={isCooldownToggled}
					onChange={(_, val) => {
						onCooldownToggle(val);
					}}
				/>
			</div>
		</div>
	);
}

export default OptionalRoundTogglers;



// WEBPACK FOOTER //
// ./src/workoutPreview/OptionalRoundTogglers.js